
import { bottom } from "@popperjs/core";

window.addEventListener('DOMContentLoaded',()=>{
    const aside = document.querySelector('.section-interview aside');
    if (aside) {
    
        document.querySelector('.section-interview aside .handle').addEventListener('click', function(){
            
            if (aside.className.indexOf(' open') >= 0) {
                aside.className = aside.className.replace(' open', '');
            }
            else {
                aside.className += ' open';
            }
        });

        let interviewLinks = document.querySelectorAll('aside a');
        if (interviewLinks.length) {
        for (let i = 0; i < interviewLinks.length; i++) {
            interviewLinks[i].addEventListener('click', function(event){
            let section = document.getElementById(interviewLinks[i].getAttribute('href').substring((interviewLinks[i].getAttribute('href').indexOf('#')+1), interviewLinks[i].getAttribute('href').length));
            let newY = window.scrollY + (section.getBoundingClientRect().y - document.querySelector('header').clientHeight - 20);
            window.scrollTo(0, newY);
            event.preventDefault();
            });
        }
        }

    }

    function slideToggle (trigger, useraction, box, duration) {
        duration?undefined:duration=300;
        let boxheight = box.clientHeight;
        box.style.height = 'auto';
        box.classList.toggle('open');
        let boxautoheight = box.clientHeight;
        box.style.height = '';
        box.classList.toggle('open');
        box.style.transition = 'height '+duration+'ms ease-in-out';
        trigger.addEventListener(useraction, function(event){
            if ( box.className.indexOf('open') == -1 ){
                box.classList.toggle('open');
                setTimeout(function(){
                    box.style.height = boxautoheight+'px';
                },1);
                setTimeout(function(){
                    if (box.parentElement.parentElement.getBoundingClientRect().y < 0) {
                        let scrollHeight = window.scrollY + box.parentElement.parentElement.getBoundingClientRect().y - 100;
                        window.scrollTo(0, scrollHeight);
                    }
                }, duration + 100);
            }
            else {
                box.style.height = '';
                setTimeout(function(){
                    box.classList.toggle('open');
                },duration);
            }
            event.preventDefault();
        })
    }

    let readmore = document.querySelectorAll('.interview-transcript-readmore a.btn');
    if (readmore) {
        for (let i = 0; i < readmore.length; i++ ) {
           slideToggle(readmore[i], 'click', readmore[i].parentElement.previousElementSibling, 300);
        }
    }
});